import { BPopover } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBPopover = createEgBootstrapProxy("EgBPopover", BPopover);
